import styles from './styles.module.scss'

const Range = ({ name, min, max, customClass, onChange, onBlur, value }) => {
  return (
    <input
      type="range"
      name={name}
      id={name}
      min={min}
      max={max}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      className={`${styles.range__input} ${customClass}`}
    />
  )
}

export default Range
